import styled, { css } from 'styled-components';

export const ModalContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: ${theme.co.secondary50};
    margin: ${theme.sz.s10} ${theme.sz.s6} ${theme.sz.s12};
    gap: ${theme.sz.s4};

    @media (min-width: ${theme.sz.md}) {
      margin: ${theme.sz.s14} ${theme.sz.s10} ${theme.sz.s18};
      gap: ${theme.sz.s6};
    }
  `,
);

export const HeaderImage = styled.img(
  ({ theme }) => css`
    height: ${theme.sz.s32};

    @media (min-width: ${theme.sz.md}) {
      height: ${theme.sz.s40};
    }
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    margin: ${theme.sz.s0};
    color: ${theme.co.secondary20};
    ${theme.typography.heading.mobile.m};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.m};
    }
  `,
);

export const Description = styled.p(
  ({ theme }) => css`
    margin: ${theme.sz.s0};
    color: ${theme.co.secondary50};
    ${theme.typography.paragraph.m};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.l};
    }
  `,
);

export const ActionButton = styled.div(
  () => css`
    width: 100%;
  `,
);
